import * as React from 'react';

import { cn } from '@/lib/utils';

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex min-h-[110px] w-full rounded-[12px] border border-border bg-raised px-3.5 py-3 text-[13.5px] text-foreground placeholder:text-muted-foreground outline-none transition-colors disabled:cursor-not-allowed disabled:opacity-50',
          'hover:border-border-strong',
          'focus-visible:border-primary focus-visible:ring-primary-soft focus-visible:ring-[4px]',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
